import { useFetchViewProjectsByIdQuery } from "../slice/logdetailSlice";
import { getProjectBudgetType, shouldShowBudgetGauge } from "../utils/budgetType";

/**
 * Whether the "Budget used %" gauge applies to a project (Fixed Cost only).
 *
 * The budget overview endpoint says so itself (`budget_type` + `budget_tracked`).
 * Until a backend that returns those fields is deployed, fall back to reading the
 * project's own `budget_type` - one extra request, made only when needed.
 *
 * @param {string|number} projectId
 * @param {object|undefined} overview   - data of the budget overview query
 * @param {boolean} overviewLoading     - loading flag of that query
 * @returns {{ budgetType: string|null, budgetTracked: boolean, loading: boolean }}
 */
export const useBudgetTracking = (projectId, overview, overviewLoading) => {
  const overviewSaysSo = typeof overview?.budget_tracked === "boolean";

  const { data: project, isLoading: projectLoading } = useFetchViewProjectsByIdQuery(projectId, {
    skip: !projectId || overviewLoading || overviewSaysSo,
  });

  if (overviewSaysSo) {
    return { budgetType: overview.budget_type ?? null, budgetTracked: overview.budget_tracked, loading: false };
  }

  const budgetType = getProjectBudgetType(project);
  return {
    budgetType,
    budgetTracked: shouldShowBudgetGauge(budgetType),
    loading: Boolean(overviewLoading) || projectLoading,
  };
};

export default useBudgetTracking;
